import React, { Component } from "react";
import Row from "../../containers/row";
import ThreeCol from "../../containers/threeCol";
import RectangleHead from "../../rectangleHead";
import FlexText from "../../flexText";

class RectangleRow extends Component {
  returnImages() {
    return this.props.rowData.map((square, index) => (
      <ThreeCol
        key={index}
        style={{
          textAlign: "center",
          lineBreak: "word",
          display: "inline-flex",
        }}
      >
        <RectangleHead
          image={square.field_image.uri}
          height="208px"
          width="370px"
          nudgeX={square.field_integer_1 + "%"}
          nudgeY={square.field_integer_2 + "%"}
          styles={{
            margin: "auto",
          }}
        />
        <FlexText
          color="#007155"
          tag="h3"
          max="20.8"
          min="17"
          styles={{ textAlign: "center" }}
        >
          {square.field_link_1.title}
        </FlexText>
        <FlexText
          tag="p"
          color="#888"
          max="17"
          min="14"
          styles={{
            textAlign: "center",
            fontFamily: "Roboto",
            textTransform: "none",
          }}
        >
          {square.field_text_1}
        </FlexText>
      </ThreeCol>
    ));
  }

  render() {
    return (
      <Row minHeight="588px" padding="120px 24px 120px 24px">
        {this.returnImages()}
      </Row>
    );
  }
}

export default RectangleRow;
